import {useEffect, useState} from "react";
import {ConversationRepository} from "../../repositories/ConversationRepository";
import {useFlowProtection} from "../../hooks/useFlowProtection";

// Today's callers over the picked language's flow, or every language's flow, merged by numberHash across flows and
// sorted by calls: [{numberHash, number, calls, conversationIds}] (null until loaded). The number is masked unless the
// protection token unlocks it. Reloaded when refreshKey changes (e.g. a call started or ended) and every refreshInterval ms.
export const useTodayCallers = ({subProjects, subProjectId, conversationType, projectVersionType, refreshKey, refreshInterval}) => {
  const [callers, setCallers] = useState(null);
  const {token: protectionToken} = useFlowProtection();
  const flowUids = (subProjects || []).filter(item => !subProjectId || String(item.id) === String(subProjectId))
    .map(item => item.flowUid).filter(Boolean).join(",");

  useEffect(() => {
    if (!flowUids) return;
    const load = () => Promise.all(flowUids.split(",").map(flowUid => ConversationRepository.getDailyCallers({
      flowUid, type: conversationType, projectVersionType: projectVersionType || undefined,
    })))
      .then(responses => {
        const byHash = {};
        responses.forEach(({data}) => (data?.numbers || []).forEach(caller => {
          const merged = byHash[caller.numberHash] || (byHash[caller.numberHash] = {...caller, calls: 0, conversationIds: []});
          merged.calls += caller.calls;
          merged.conversationIds = [...merged.conversationIds, ...caller.conversationIds];
        }));
        setCallers(Object.values(byHash).sort((a, b) => b.calls - a.calls));
      })
      .catch(() => setCallers(null));
    load();
    if (!refreshInterval) return;
    const intervalId = setInterval(load, refreshInterval);
    return () => clearInterval(intervalId);
  }, [flowUids, conversationType, projectVersionType, refreshKey, refreshInterval, protectionToken]);

  return callers;
};
